<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    id="right-arrow-path"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.5401 11.8579H1.91675C0.952915 11.8579 0.166748 11.0717 0.166748 10.1079C0.166748 9.14403 0.952915 8.35786 1.91675 8.35786H13.5442L8.85427 3.64867C8.17146 2.96587 8.17146 1.86152 8.85427 1.17871C9.53708 0.495907 10.6414 0.495907 11.3249 1.17934L19.0009 8.87871C19.6837 9.56152 19.6837 10.6659 19.0009 11.3487L11.3126 19.037C10.6298 19.7198 9.52541 19.7198 8.8426 19.037C8.1598 18.3542 8.1598 17.2382 8.8426 16.5554L13.5401 11.8579Z"
    [attr.fill]="fillColor"
  />
</svg>